'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _themeSections = require('@shopify/theme-sections');

require('../sections/redirect-modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export new redirect helper function.
 */
exports.default = function () {

  /**
   * Initialise component.
   */
  function init() {
    setListeners();
    handleRedirectWarning();
  }

  /**
   * Set component listeners.
   */
  function setListeners() {
    Frame.EventBus.listen('LanguageSelector:change', function (response) {
      return onLanguageChange(response);
    });
  }

  /**
   * Handle GeoIP country code and store country code matching.
   * @param {object} response - ipstack success response.
   */
  function onLanguageChange(response) {
    handleRedirects(response);
  }

  /**
   * Handle url redirect locations.
   * @param {object} response - ipstack success response.
   */
  function handleRedirects(response) {
    window.setTimeout(function () {
      window.location = getRedirectURL(response.selected);
    }, 1500);
  }

  /**
   * Get redirect URL defined in redirect modal section.
   * @param {String} location - Location country/continent code.
   */
  function getRedirectURL(location) {
    return Frame.Redirects.filter(function (element) {
      return element.country_code === location || element.continent_code === location;
    })[0].store_url;
  }

  /**
   * Check if user is coming from a location that doesn't match the store.
   */
  function handleRedirectWarning() {
    if (isCookieSet() && _jsCookie2.default.get('default_language') !== theme.store.countryCode) {
      (0, _themeSections.load)('*');
    }
  }

  /**
   * Check if cookies have been set.
   */
  function isCookieSet() {
    return typeof _jsCookie2.default.get('default_language') !== 'undefined';
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init
  });
}; /**
    * Helper: Redirects
    * ------------------------------------------------------------------------------
    * An event based redirect module listening for language/location event changes.
    *
    * @namespace redirects
    */